<template>
    <div class="productAddWrap11">
        <div class="desBox">
            <div class="textBox">
                <span class="titleText">操作说明</span>
                <span class="desText">
                    <span class="first">1.带<span class="red">*</span>号的为必填项 </span>
                    <span>2.请仔细填写相应信息</span>
                </span>

            </div>
        </div>
        <div class="formBox">
            <el-form :model="ruleForm" :inline-message="true" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
                <el-form-item label="所属公司&品牌" required>
                    <div class="inlineInputBox">
                        <el-form-item prop="company">
                            <el-select v-model="ruleForm.company" placeholder="请选择公司名称" @change="getBrandLists">
                                <el-option :label="list.companyName" :value="list.userId" v-for="(list,index) in companyLists" :key="list.userId"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="inlineInputBox">
                        <el-form-item prop="brand">
                            <el-select v-model="ruleForm.brand" placeholder="请选择品牌">
                                <el-option :label="list.brandName" :value="list.brandName" v-for="(list,index) in brandLists" :key="list.brandId"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="inlineInputBox">
                        <el-button type="success">添加品牌</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="商品名称" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="款号" prop="kuanhao">
                    <el-input v-model="ruleForm.kuanhao" placeholder="请输入款号"></el-input>
                    <span class="memo">注：一个颜色作为一个款，多个颜色视为多款</span>
                </el-form-item>
                <el-form-item label="颜色" prop="color">
                    <el-input v-model="ruleForm.color" placeholder="请输入商品颜色" />
                    </el-input>
                </el-form-item>
                <el-form-item label="尺码" prop="size">
                    <el-input v-model="ruleForm.size" placeholder="请输入商品尺码"></el-input>
                    <span class="memo">注：各尺码用空格隔开，如：S M L</span>
                </el-form-item>
                <el-form-item label="类目" prop="type">
                    <el-input v-model="ruleForm.type" placeholder="请输入商品所属类目"></el-input>
                </el-form-item>
                <el-form-item label="吊牌价" prop="dpprice" required>
                    <el-input v-model="ruleForm.dpprice" placeholder="请输入商品吊牌价"></el-input>
                    <span class="memo">元</span>
                </el-form-item>
                <el-form-item label="订货价" prop="dhprice" required>
                    <el-input v-model="ruleForm.dhprice" placeholder="请输入商品订货价"></el-input>
                    <span class="memo">元</span>
                </el-form-item>
                <el-form-item label="是否为主推款" prop="isMain">
                    <el-radio-group v-model="ruleForm.isMain">
                        <el-radio :label="'y'">是</el-radio>
                        <el-radio :label="'n'">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="上传商品图片" required>
                    <div class="uploadWrap">
                        <el-upload  action=""  list-type="picture-card" :auto-upload="false" :on-change="changeUpload" :on-remove="removeImg" accept="image/png, image/jpeg, image/jpg">  
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                    <span class="memo">注：首张图片视为主图，建议图片.png或.jpg格式，大小不超过10M</span>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {json,wordData,utils} from '@/common/common.js'
    import axios from 'axios'
    import {api,ajaxPost} from '@/common/request.js'
    export default {
        name: 'HelloWorld',
        data() {
            var priceValidate = (rule, value, callback) => {
                if (value == '') {
                    callback(new Error('请输入价格'));
                } else if (isNaN(value)) {
                    callback(new Error('必须为数字!'));
                } else if (value <= 0) {
                    callback(new Error('必须大于0!'));
                } else {
                    callback()
                }
            };
            return {
                companyLists:[],
                brandLists:[],
                fileLists:[],
                conferenceId:'',
                dialogImageUrl: '',
                dialogVisible: false,
                ruleForm: {
                    company:'',
                    brand:'',
                    isMain:'',
                },
                rules: {
                    company: [{
                        required: true,
                        message: '公司未选择',
                        trigger: 'change'
                    }],
                    brand: [{
                        required: true,
                        message: '品牌未选择',
                        trigger: 'change'
                    }],
                    name: [{
                        required: true,
                        message: '商品名称必填',
                        trigger: 'blur'
                    }],
                    kuanhao: [{
                        required: true,
                        message: '款号必填',
                        trigger: 'blur'
                    }],
                    color: [{
                        required: true,
                        message: '颜色必填',
                        trigger: 'blur'
                    }, ],
                    size: [{
                        required: true,
                        message: '尺码必填',
                        trigger: 'blur'
                    }],
                    type: [{
                        required: true,
                        message: '类目必填',
                        trigger: 'blur'
                    }],
                    dpprice: [{
                        validator: priceValidate,
                        trigger: 'blur'
                    }],
                    dhprice: [{
                        validator: priceValidate,
                        trigger: 'blur'
                    }],
                    isMain: [{
                        required: true,
                        message: '是否为主推款',
                        trigger: 'blur'
                    }, ],
                },
            }
        },
        methods: {
            getCompanyLists(){
                let _this=this
                let arg={
                    conferenceId:this.conferenceId
                }
                ajaxPost('/admin/addmallitemcompanyList', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.companyLists=res.data
                    }
                     
                }, function(res) {
                
                })
            },
            getBrandLists(){
                let _this=this
                this.ruleForm.brand=''
                let arg={
                    userId:_this.ruleForm.company
                }
                ajaxPost('/admin/addmallitembrandList', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.brandLists=res.data
                    }
                     
                }, function(res) {
                
                })
            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
                console.log(this.$route.params)
            },
            changeUpload(file,fileList){
              console.log("fileList--------")  
              console.log(fileList)  
              this.fileLists=fileList
            },
            removeImg(file,fileList){
              console.log("removeImg,filelist")  
              console.log(fileList)  
              this.fileLists=fileList
            },
            submitForm(formName) {
                let _this = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {//ces
                    //1.图片
                        if(_this.fileLists.length==0){
                            alert("至少上传一张图片")
                            return false
                        }
                        var formdata = new FormData();
                        for(let k=0; k < _this.fileLists.length; k++){
                            console.log(_this.fileLists[k])
                          formdata.append('files',_this.fileLists[k].raw);
                        }
                        console.log(formdata,'formdata----666')
                        // 2.尺码
                        _this.ruleForm.size.replace(/\s+/g, ' ');
                        // 3.组装所有
                        let arg_form={
                            userId:_this.ruleForm.company,
                            brandName:_this.ruleForm.brand,
                            styleNumber:_this.ruleForm.kuanhao,
                            colorName:_this.ruleForm.color,
                            sizeName:_this.ruleForm.size,
                            itemName:_this.ruleForm.name,
                            itemOrderPrice:_this.ruleForm.dhprice,
                            itemOriginalPrice:_this.ruleForm.dpprice,
                            categoryName:_this.ruleForm.type,
                            itemIsRecommend:_this.ruleForm.isMain,
                            conferenceId:_this.conferenceId,
                        }
                        for(var key in arg_form){
                            formdata.append(key,arg_form[key])
                        }
                        // formdata.append('data', JSON.stringify({
                        //   ...arg_form
                        // }))
                        // 4.header
                        let headers = {headers: {"Content-Type": "multipart/form-data"}}
                        // 5.ajax
                        axios.post(api.baseUrl+'/admin/addMallItem', formdata, headers).then(function(res){
                            if(res.data.errorCode==200){
                                _this.$message({
                                    message: "上传成功", //接口返回一个页面
                                    type: 'success',
                                    duration: 2000
                                });
                                setTimeout(function(){
                                    _this.$router.back()
                                },500)
                                
                            }else{
                                _this.$message({
                                    message: "上传商品失败", //接口返回一个页面
                                    type: 'warning',
                                    duration: 1000
                                });
                            }
                            
                        },function(res){
                            _this.$message({
                                message: "捕获异常", //接口返回一个页面
                                type: 'warning',
                                duration: 1000
                            });
                        })
                    } else {
                        _this.$message({
                            message: "表单填写不完整或格式不正确", //接口返回一个页面
                            type: 'warning',
                            duration: 1000
                        });
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
        mounted(){
            this.getParams()
            this.getCompanyLists()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .productAddWrap11 {
        .inlineInputBox {
            display: inline-block;
        }

        .el-input {
            width: 217px;
        }

        .el-form-item {
            margin-bottom: 5px;
        }

        background: #fff;
        padding:0 30px 20px 30px;

        .desBox {
            padding: 10px 0;
            background: #ddd;
            width: 900px;
            padding-right: 22px;

            .textBox {
                border-left: 4px solid skyblue;
                padding-left: 20px;
                font-size: 12px;

                .titleText {
                    font-weight: bold;
                    margin-right: 30px;
                }

                .first {
                    margin-right: 30px;
                }
            }

            // padding:10px 30px; background: #eee;font-size: 12px;  
            // .titleBox{border-left:2px solid skyblue;padding-left:20px;margin-bottom: 10px;font-weight: bold;height: 11px;line-height: 11px;}
        }

        .formBox {
            padding-top: 10px;
            background: #fff;
            padding: 10px;
            border: 1px solid #ccc;
            border-top: 0;
            width: 900px;

            .memo {
                color: #999;
                font-size: 12px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/productAdd.vue